const wapIndex = () => import('@/views/wap/index');
const physicalExamination = () => import('@/views/wap/physicalExamination');
const myFamilyPhysical = () => import('@/views/wap/myFamilyPhysical');
const myPhysical = () => import('@/views/wap/myPhysical');
const staffConfirm = () => import('@/views/wap/staffConfirm');
const choosePkg = () => import('@/views/wap/choosePkg');
const chooseKxPkg = () => import('@/views/wap/chooseKxPkg');
const chooseAudioPkg = () => import('@/views/wap/chooseAudioPkg');
const confirmPkg = () => import('@/views/wap/confirmPkg');
const settleAccounts = () => import('@/views/wap/settleAccounts');
const wapFamily = () => import('@/views/wap/family');
const wapReportList = () => import('@/views/wap/reportList')
const wapLogin = () => import('@/views/wap/login');
const wapBindPhone = () => import('@/views/wap/bindphone');
const wapDetail = () => import('@/views/wap/detail');
const wapExamDetail = () => import('@/views/wap/examDetail');
const wapOption = () => import('@/views/wap/optionBag');
const wapNoticeDetail = () => import('@/views/wap/noticeDetail')
const wapConfirm = () => import('@/views/wap/orderConfirm');
const wapPay = () => import('@/views/wap/pay');
const wapRegions = () => import('@/views/wap/regions_goods');
const wapOrderRegions = () => import('@/views/wap/regions');
const wapInstitutions = () => import('@/views/wap/institutions_goods');
const wapOrderInstitutions = () => import('@/views/wap/institutions');
const wapChooseDate = () => import('@/views/wap/choosedate');
const wapAppointmentDetail = () => import('@/views/wap/appointment_detail');
const wapAppointment = () => import('@/views/wap/appointment_goods');
const wapOrderAppointment = () => import('@/views/wap/appointment');
const wapResult = () => import('@/views/wap/result');
const wapSurvey = () => import('@/views/wap/survey')
const wapFeedback = () => import('@/views/wap/feedback')
const searchInstitution = () => import('@/views/wap/searchInstitution');

const wapOrderDetail = () => import('@/views/wap/orderDetail')

const wapReimbursement = () => import('@/views/wap/reimbursement')
const wapReimbursementAdd = () => import('@/views/wap/reimbursement_add')
const wapReimbursementDetail = () => import('@/views/wap/reimbursement_detail')


const basePath = '/hms/wap';
export default [
  // 首页
  {
    path: basePath + '/index',
    name: 'wapIndex',
    component: wapIndex,
    meta: {
      title: '线上预约系统'
    }
  },
  // 体检须知
  {
    path: basePath + '/physicalExamination',
    name: 'wapPhysicalExamination',
    component: physicalExamination,
    meta: {
      title: '体检须知'
    }
  },
  // 公告详情页
  {
    path: basePath + '/noticeDetail',
    name: 'wapNoticeDetail',
    component: wapNoticeDetail,
    meta: {
      title: '系统公告'
    }
  },
  // 我的体检
  {
    path: basePath + '/myPhysical',
    name: 'wapMyPhysical',
    component: myPhysical,
    meta: {
      title: '我的体检'
    }
  },
  // 体检人信息确认
    {
      path: basePath + '/staffConfirm',
      name: 'staffConfirm',
      component: staffConfirm,
      meta: {
        title: '我的体检'
      }
    },
  // 我的体检
  {
    path: basePath + '/myFamilyPhysical',
    name: 'wapMyFamilyPhysical',
    component: myFamilyPhysical,
    meta: {
      title: '我的体检'
    }
  },
  // 选择加项目包
  {
    path: basePath + '/choosePkg',
    name: 'wapChoosePkg',
    component: choosePkg,
    meta: {
      title: '加项包'
    }
  },
  // 选择语音加项包
  {
    path: basePath + '/chooseAudioPkg',
    name: 'wapChooseAudioPkg',
    component: chooseAudioPkg,
    meta: {
      title: '语音加项包'
    }
  },
  // 选择加项目包
  {
    path: basePath + '/chooseKxPkg',
    name: 'wapChooseKxPkg',
    component: chooseKxPkg,
    meta: {
      title: '自选加项包'
    }
  },
  // 查看可约机构
  {
    path: basePath + '/searchInstitution',
    name: 'wapSearchInstitution',
    component: searchInstitution,
    meta: {
      title: '机构选择'
    }
  },
  // 确认套餐
  {
    path: basePath + '/confirmPkg',
    name: 'wapConfirmPkg',
    component: confirmPkg,
    meta: {
      title: '确认套餐'
    }
  },
  // 满意度调查问卷
  {
    path: basePath + '/survey',
    name: 'wapSurvey',
    component: wapSurvey,
    meta: {
      title: '满意度调查'
    }
  },
  // 支付
  {
    path: basePath + '/settleAccounts',
    name: 'wapSettleAccounts',
    component: settleAccounts,
    meta: {
      title: '支付'
    }
  },
  // 家属套餐页
  {
    path: basePath + '/family',
    name: 'wapFamily',
    component: wapFamily,
    meta: {
      title: '家属套餐'
    }
  },
  // 登录页
  {
    path: basePath + '/login',
    name: 'wapLogin',
    component: wapLogin,
    meta: {
      title: '登录'
    }
  },
  // 历年报告列表页
  {
    path: basePath + '/report_list',
    name: 'wapReportList',
    component: wapReportList,
    meta: {
      title: '历年报告'
    }
  },
  // 绑定手机页
  {
    path: basePath + '/bindphone',
    name: 'wapBindPhone',
    component: wapBindPhone,
    meta: {
      title: '绑定手机'
    }
  },
  // 套餐详情页
  {
    path: basePath + '/detail',
    name: 'wapDetail',
    component: wapDetail,
    meta: {
      title: '详情'
    }
  },
  // 套餐详情页
  {
    path: basePath + '/examDetail',
    name: 'wapExamDetail',
    component: wapExamDetail,
    meta: {
      title: '套餐详情'
    }
  },
  // 可选包
  {
    path: basePath + '/option',
    name: 'wapOption',
    component: wapOption,
    meta: {
      title: '详情'
    }
  },
  // 订单确认页
  {
    path: basePath + '/confirm',
    name: 'wapConfirm',
    component: wapConfirm,
    meta: {
      title: '确认套餐'
    }
  },
  // 支付页
  {
    path: basePath + '/pay',
    name: 'wapPay',
    component: wapPay,
    meta: {
      title: '支付'
    }
  },
  // 有orderCode后选择地区
  {
    path: basePath + '/orderRegions',
    name: 'wapOrderRegions',
    component: wapOrderRegions,
    meta: {
      title: '选择地区'
    }
  },
  // 选择地区
  {
    path: basePath + '/regions',
    name: 'wapRegions',
    component: wapRegions,
    meta: {
      title: '选择地区'
    }
  },
  // 有orderCode后选择机构
  {
    path: basePath + '/orderInstitutions',
    name: 'wapOrderInstitutions',
    component: wapOrderInstitutions,
    meta: {
      title: '选择机构'
    }
  },
  // 选择机构
  {
    path: basePath + '/institutions',
    name: 'wapInstitutions',
    component: wapInstitutions,
    meta: {
      title: '选择地区'
    }
  },
  // 选择预约日期
  {
    path: basePath + '/choosedate',
    name: 'wapChooseDate',
    component: wapChooseDate,
    meta: {
      title: '选择预约日期'
    }
  },
  // 预约详情页
  {
    path: basePath + '/appointment_detail',
    name: 'appointment_detail',
    component: wapAppointmentDetail,
    meta: {
      title: '预约信息'
    }
  },
  // 有了orderCode完善预约信息
  {
    path: basePath + '/orderAppointment',
    name: 'wapOrderAppointment',
    component: wapOrderAppointment,
    meta: {
      title: '确认订单'
    }
  },
  // 完善预约信息
  {
    path: basePath + '/appointment',
    name: 'wapAppointment',
    component: wapAppointment,
    meta: {
      title: '确认订单'
    }
  },
  // 我要反馈
  {
    path: basePath + '/feedback',
    name: 'wapFeedback',
    component: wapFeedback,
    meta: {
      title: '我要反馈'
    }
  },
  // 结果页
  {
    path: basePath + '/result',
    name: 'wapResult',
    component: wapResult,
    meta: {
      title: '结果'
    }
  },
  // 订单详情页
  {
    path: basePath + '/orderDetail',
    name: 'wapOrderDetail',
    component: wapOrderDetail,
    meta: {
      title: '订单详情'
    }
  },
  // 体检线上报销
  {
    path: basePath + '/reimbursement',
    name: 'wapReimbursement',
    component: wapReimbursement,
    meta: {
      title: '体检线上报销'
    }
  },
  // 体检线上报销添加
  {
    path: basePath + '/reimbursementAdd',
    name: 'wapReimbursementAdd',
    component: wapReimbursementAdd,
    meta: {
      title: '体检线上报销'
    }
  },
  // 线上报销详情
  {
    path: basePath + '/reimbursementDetail',
    name: 'wapReimbursementDetail',
    component: wapReimbursementDetail,
    meta: {
      title: '体检线上报销'
    }
  }
]
